var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLashUnder = function SvgLashUnder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 38,
    height: 29,
    viewBox: "0 0 0.7 0.53",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.09;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2313160081232"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.62.16C.65.17.56.23.53.25.31.36.22.29.05.15.22.01.39.01.62.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.14.22C.14.24.06.36.05.41M.35.31C.35.37.34.43.34.49M.55.26c.03.03.07.07.1.09"
  })))));
};

export default SvgLashUnder;